import createVueApp from '@phoenix/createVueApp';
import { PhxsgProductAnimation } from '@sg/src/View/Components/Molecules/ProductAnimation';

import PhxsgSlide from './phxsg-slide.vue';
import PhxsgSlider from './phxsg-slider.vue';

document.querySelectorAll('[data-component="phxsg-slider"]').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgProductAnimation', PhxsgProductAnimation);
  app.component('PhxsgSlider', PhxsgSlider);
  app.component('PhxsgSlide', PhxsgSlide);
  app.mount(el);
});
